import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AuthAdminGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authService.checkAuthCookie()) {

      this.authService.getAuthCookie();

      if ( this.authService.auth.groupid !== '23428' && this.authService.getApp() === 'MyDesign3' ) {
        this.router.navigate(['/templates']);
      }

      if ( this.authService.auth.client.office_id !== '919' && this.authService.getApp() === 'Designly' ) {
        this.router.navigate(['/templates']);
      }

      return true;
    }

    this.router.navigate(['/login']);

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth-admin-guard.service.ts